export default __webpack_public_path__ + "static/media/logo.2abe0e57.jpg";